import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { appSetToggle, setConfirm } from "../../store/actions/appAction";
import { resetFormState } from "../../store/actions/formAction";
import { apiDeleteBranch, apiGetBranches } from "../../api/branchApi";

import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import IconEdit from "../../assets/svg/pen-icon-account.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";
import logoInventories from "../../assets/svg/logoInventories.svg";
import backgroundInventories from "../../assets/svg/backgroundInventories.svg";
import addNewWarehouse from "../../assets/svg/add-new-warehouse.svg";
import addWork from "../../assets/svg/registerShow/icon-add-work.svg";

import "../../assets/styles/inventory/showWerhoues.scss";
import { apiDeleteCostCenter, apiGetCostCenters } from "../../api/costCenterApi";

export default function CostCenters() {
  const dispatch = useDispatch();

  const costCenters = useSelector((state) => state).costCenterReducer.costCenters;
  const toggle = useSelector((state) => state.appReducer.toggle);
  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
  const token = useSelector((state) => state).businessReducer.business?.token;

  const [showCostCenterActions, setShowCostCenterActions] = useState(null);

  useEffect(() => {
    dispatch(resetFormState());
    fetchCostCenters();
  }, []);

  useEffect(() => {
    fetchCostCenters();
  }, [sendingRequest]);

  useEffect(() => {
    if (!toggle) setShowCostCenterActions(toggle);
  }, [toggle]);

  const fetchCostCenters = () => {
    dispatch(apiGetCostCenters(token));
  };

  const toggleShowCostCenterActions = (id) => {
    dispatch(appSetToggle(showCostCenterActions !== id));
    setShowCostCenterActions(showCostCenterActions === id ? null : id);
  };

  return (
    <div className="wrap-inventory">
      <div className="header-inventory">
        <div className="header-right">
          <div>مرکز هزینه ها</div>
          <div>لیست مرکز هزینه ها</div>
        </div>
      </div>
      <div className="body-cards row">
        <AddCostCenterCard />
        {costCenters.map((costCenter, index) => (
          <CostCenterCard
            key={index}
            costCenter={costCenter}
            active={toggle && showCostCenterActions === costCenter.id}
            toggleShowCostCenterActions={toggleShowCostCenterActions}
          />
        ))}
      </div>
    </div>
  );
}

const AddCostCenterCard = () => {
  const navigate = useNavigate();

  return (
    <a
      className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card"
      href="/costCenters/add"
      onClick={(e) => {
        navigate("/costCenters/add");
        e.preventDefault();
      }}
    >
      <div className="add-shareholder">
        <div className="wrap-add-shareholder">
          <div className="item-add-shareholder">
            <div className="wrap-icon-add-shareholder">
              <img src={addNewWarehouse} alt="addNewUsers" />
            </div>
            <div className="add-shareholder-new">
              <img className="add-icon-shareholder" src={addWork} alt="addWork" />
              افزودن مرکز هزینه جدید
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

const CostCenterCard = ({ costCenter, active, toggleShowCostCenterActions }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state) => state).businessReducer.business.token;
  const secretView = useSelector((state) => state.appReducer.secretView);

  const deleteCostCenter = (id) => {
    dispatch(setConfirm("مرکز هزینه", () => dispatch(apiDeleteCostCenter(id, token))));
  };

  return (
    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card">
      <div className="card-box">
        <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
          <a
            href={`/costCenters/${costCenter.id}`}
            onClick={(e) => {
              navigate(`/costCenters/${costCenter.id}`);
              e.preventDefault();
            }}
          >
            <img src={IconEdit} alt="IconEdit" />
            ویرایش
          </a>
          <div onClick={() => deleteCostCenter(costCenter.id)}>
            <img src={IconDelete} alt="IconEdit" />
            حذف مرکز هزینه
          </div>
        </div>
        <img className="logo-original" src={backgroundInventories} alt="original-logo" />
        <div className="header-card">
          <div className="right-header-card">
            <div />
            <div />
            <div className="logo-card">
              <img src={logoInventories} alt="logo-bank" />
            </div>
          </div>
          <div className="left-header-card">
            <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowCostCenterActions(costCenter.id)} />
          </div>
        </div>
          {secretView ? "********" : costCenter.title}
        <div className="line-card" />
        <div className="footer-card" />
      </div>
    </div>
  );
};
